import React from 'react'
import { observer } from 'mobx-react-lite'
import { t, Trans } from '@lingui/macro'
import { _ } from '../../utils/intl'
import {
  Button,
  ButtonLayout,
  DialogContent,
  DialogFooter,
  DialogHeader,
  ReachDialog,
} from '../../ui-kit'

export const ChangePinModal: React.FC<{ close: () => void }> = observer(({ close }) => {
  return (
    <ReachDialog onDismiss={close}>
      <DialogHeader title={_(t`Zabudnutý pin`)} />
      <DialogContent>
        <Trans>
          Ak ste zabudli PIN kód a chcete ho zmeniť, kontaktujte, prosím, Vášho zamestnávateľa.
        </Trans>
      </DialogContent>
      <DialogFooter>
        <ButtonLayout direction="horizontal" className="align-items-right">
          <Button onClick={close}>
            <Trans>Zatvoriť</Trans>
          </Button>
        </ButtonLayout>
      </DialogFooter>
    </ReachDialog>
  )
})
